import React from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { Intent } from '@teetsh/app/src/components/Buttons/BaseButtonProps';
import { Icon } from '@teetsh/app/src/components/Icons/icon';
import { useTranslation } from 'react-i18next';

interface Props {
  title?: string;
  isOpen: boolean;
  closeModalFct: () => void;
  body?: string | React.ReactNode;
  buttonIcon?: Icon;
  validateTitle?: string;
  cancelTitle?: string;
  isLoading?: boolean;
  intent?: Intent;
  validateAction?: () => void;
  noCancel?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
}

export default function SimpleModal({
  title,
  isOpen,
  closeModalFct,
  body,
  buttonIcon,
  validateTitle,
  intent,
  isLoading,
  validateAction,
  noCancel = false,
  disabled = false,
  cancelTitle,
  children,
}: Props) {
  const { t } = useTranslation(['common']);
  return (
    <Dialog size="md" isOpen={isOpen} onClose={closeModalFct} title={title}>
      <Dialog.Body>{body || children}</Dialog.Body>
      {validateAction && (
        <Dialog.Footer>
          {!noCancel && (
            <Button minimal large onClick={closeModalFct}>
              {cancelTitle || t('common:buttons.cancel')}
            </Button>
          )}
          <Button
            large
            disabled={disabled}
            loading={isLoading}
            intent={intent || 'danger'}
            onClick={validateAction}
            icon={buttonIcon}
          >
            {validateTitle || t('common:buttons.validate')}
          </Button>
        </Dialog.Footer>
      )}
    </Dialog>
  );
}
